import { withStyles } from 'vopay'; // _TODO: import { Button } from 'UI'
import styles from './MsEntraButton.module.scss';
import { Button } from 'UI';
import { useMsal } from '@azure/msal-react';
import { InteractionStatus, BrowserAuthError } from '@azure/msal-browser';
import { useAlertDialog } from '@/providers/AlertDialog.provider';

import MSLogo from './MsLogo';
import { useEffect } from 'react';

const cn = withStyles(styles);

export type LoginResult = { email: string; accessToken: string };

type MSEntraButtonProps = {
  onOpen: (open: boolean) => void;
  onLogin: (res: LoginResult) => void;
};

export default function MSEntraButton({ onOpen, onLogin }: MSEntraButtonProps) {
  const { instance: msalInstance, inProgress } = useMsal();
  const usingMs = inProgress === InteractionStatus.Login || inProgress === InteractionStatus.AcquireToken;
  const alertDialog = useAlertDialog();

  useEffect(() => {
    onOpen(usingMs);
  }, [inProgress]);

  async function handleLogin() {
    try {
      const res = await msalInstance.loginPopup();

      if (res)
        onLogin({
          email: res.account.username,
          accessToken: res.accessToken,
        });
    } catch (err) {
      if (err instanceof BrowserAuthError && err.errorCode === 'user_cancelled') {
        // User closed the popup, don't treat as error
        console.log('User cancelled login');
        return;
      } else {
        console.error(err);

        if (err instanceof Error) {
          alertDialog.error('Error', err.message);
        }
      }
    }
  }

  return (
    <>
      <Button onClick={handleLogin} disabled={usingMs}>
        <div className={cn('msEntraButton')}>
          <MSLogo />

          <div>Continue with Microsoft</div>
        </div>
      </Button>
    </>
  );
}
